import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button, Modal, Tooltip, Input, Descriptions } from "antd";
import { UserOutlined } from "@ant-design/icons";

const { Search } = Input;

const UserStatusModal = ({ application, getStatusForIdentity }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [userStatus, setUserStatus] = useState();

  const clear = () => {
    setIsModalOpen(false);
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    clear();
  };

  const handleOk = async () => {
    setIsModalOpen(false);
  };

  const search = async (value) => {
    setIsLoading(true);
    const action = await getStatusForIdentity(application.id, value);
    if (action?.payload?.data) setUserStatus(action.payload.data);
    setIsLoading(false);
  };

  const statusInfo = [
    {
      label: "Display Name",
      children: userStatus?.identityInfo?.displayName,
    },
    {
      label: "UPN",
      children: userStatus?.identityInfo?.upn,
    },
    {
      label: "Email",
      children: userStatus?.identityInfo?.email,
    },
    {
      label: "Status",
      children: userStatus?.status,
    },
    {
      label: "Grace Period End Date",
      children: userStatus?.gracePeriodEndDate,
    },
    {
      label: "Last Status Change Time",
      children: userStatus?.lastStatusChangeTime,
    },
  ];

  return (
    <>
      <Tooltip title="Check User Status">
        <Button icon={<UserOutlined />} size="middle" onClick={openModal} />
      </Tooltip>
      <Modal
        title={"Check User Status for " + application.displayName}
        open={isModalOpen}
        onCancel={handleCancel}
        onClose={handleCancel}
        onOk={handleOk}
        okText="Close"
        cancelButtonProps={{ style: { display: "none" } }}
      >
        <Search
          placeholder="Search by username"
          allowClear
          onChange={(e) => search(e.target.value)}
          onPressEnter={(e) => search(e.target.value)}
          onClear={() => search()}
          loading={isLoading}
        />

        <Descriptions title="User Status Info" column={1} items={statusInfo} />
      </Modal>
    </>
  );
};

UserStatusModal.propTypes = {
  application: PropTypes.object.isRequired,
  getStatusForIdentity: PropTypes.func.isRequired,
};

export default UserStatusModal;
